{/* Technical draft — must be reviewed by a legal professional before going live. */}

export function ImpressumPage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Impressum</h1>

      <div className="prose prose-sm max-w-none text-text-secondary">
        <h2 className="font-serif text-xl">Anbieter dieser Webseite gem. § 5 TMG:</h2>
        <p className="mb-4">
          Dr. Eugen Funk<br />
          12524 Berlin<br />
          Deutschland
        </p>

        <h2 className="font-serif text-xl mt-6 mb-2">Kontakt:</h2>
        <p className="mb-4">
          E-Mail: patent@pmfunk.de
        </p>

        <h2 className="font-serif text-xl mt-6 mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</h2>
        <p className="mb-4">
          Dr. Eugen Funk, Anschrift wie oben
        </p>

        <h2 className="font-serif text-xl mt-6 mb-2">EU-Streitschlichtung:</h2>
        <p className="mb-4">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="ml-1">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>

        <p className="mb-4">
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2 className="font-serif text-xl mt-6 mb-2">Haftungsausschluss:</h2>
        <p className="mb-4">
          Die Inhalte dieser Webseite wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
          Für Links auf externe Webseiten gilt:Wir haben keinen Einfluss auf die Inhalte dieser
          Seiten und übernehmen keine Haftung dafür.
        </p>
      </div>

      {/* Team block */}
      <div className="mt-16 pt-12 border-t border-gray-200">
        <h2 className="text-2xl font-serif mb-2">Das Team</h2>
        <p className="text-sm text-[#78786C] mb-8">Die Erfinder hinter Patent US 11914489</p>

        <img
          src="https://nx67536.your-storageshare.de/s/eHH8PJK9fyjg25d/preview"
          alt="Teamfoto"
          className="w-full rounded-xl object-cover mb-10 shadow-sm"
        />

        <p className="text-[#555] leading-relaxed mb-8">
          Das Patent wurde von einem Team aus Forschern und Ingenieuren entwickelt, die über tiefgehende Expertise in Robotik, autonomen Systemen und KI verfügen. Ihre Arbeit wurde von führenden deutschen Wirtschafts- und Technologieinstitutionen anerkannt.
        </p>

        <p className="text-sm font-bold text-[#78786C] uppercase tracking-widest mb-6">Bekannt aus</p>
        <div className="flex flex-wrap items-center gap-8">
          <img src="https://nx67536.your-storageshare.de/s/ayaYLT4G3B439yC/preview" alt="cio.de" className="h-14 object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all" />
          <img src="https://nx67536.your-storageshare.de/s/nqbgQzGGHA35CCk/preview" alt="Frankfurter Allgemeine" className="h-14 object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all" />
          <img src="https://nx67536.your-storageshare.de/s/ssmGrG4bptwf5QN/preview" alt="Digitale Technologien" className="h-14 object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all" />
          <img src="https://nx67536.your-storageshare.de/s/LA3NKXRbHEgd7eZ/preview" alt="Berlin Deep Tech" className="h-14 object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all" />
          <img src="https://nx67536.your-storageshare.de/s/8Tf9xrTBEi3f9Yy/preview" alt="Innovationspreis Berlin Brandenburg" className="h-14 object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all" />
        </div>
      </div>
    </div>
  );
}
